"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.checkAirportFilterItemSelected = checkAirportFilterItemSelected;
exports.checkAirportFilterStateReset = checkAirportFilterStateReset;
exports.checkAllAirportFilterItemsSelected = checkAllAirportFilterItemsSelected;
exports.checkAllFilterItemsSelected = checkAllFilterItemsSelected;
exports.checkAllNestedMultiSelectFilterItemsSelected = checkAllNestedMultiSelectFilterItemsSelected;
exports.checkFilterItemSelected = checkFilterItemSelected;
exports.checkFilterStateReset = checkFilterStateReset;
exports.checkMultiSelectFilterItemSelected = checkMultiSelectFilterItemSelected;
exports.checkMultiSelectFilterStateReset = checkMultiSelectFilterStateReset;
exports.checkNestedMultiSelectFilterItemSelected = checkNestedMultiSelectFilterItemSelected;
exports.checkNestedMultiSelectFilterStateReset = checkNestedMultiSelectFilterStateReset;
exports.checkPriceFilterStateReset = checkPriceFilterStateReset;
exports.checkSubFilterStateReset = checkSubFilterStateReset;
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _every2 = _interopRequireDefault(require("lodash/every"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _some2 = _interopRequireDefault(require("lodash/some"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function checkFilterStateReset(filterKey, filterState) {
  switch (filterKey) {
    case 'price':
      return checkPriceFilterStateReset(filterState);
    case 'airline':
      return checkMultiSelectFilterStateReset(filterState);
    case 'airport':
      return checkAirportFilterStateReset(filterState);
    case 'stop':
      return checkMultiSelectFilterStateReset(filterState);
    case 'maxStop':
      return checkMultiSelectFilterStateReset(filterState);
    case 'departureTime':
      return checkNestedMultiSelectFilterStateReset(filterState);
    case 'arrivalTime':
      return checkNestedMultiSelectFilterStateReset(filterState);
    case 'hasBaggageOnly':
      return filterState;
    case 'isFlex':
      return filterState;
    default:
      return false;
  }
}
function checkSubFilterStateReset(_ref) {
  var filterKey = _ref.filterKey,
    filterState = _ref.filterState,
    filterPayload = _ref.filterPayload;
  var index = (0, _get2.default)(filterPayload, 'index');
  var type = (0, _get2.default)(filterPayload, 'type');
  switch (filterKey) {
    case 'airport':
      return checkMultiSelectFilterStateReset((0, _get2.default)(filterState, index + "." + type));
    case 'departureTime':
      return checkMultiSelectFilterStateReset(filterState[index]);
    case 'arrivalTime':
      return checkMultiSelectFilterStateReset(filterState[index]);
    default:
      return false;
  }
}
function checkMultiSelectFilterStateReset(filterState) {
  return (0, _some2.default)(filterState, 'selected');
}
function checkNestedMultiSelectFilterStateReset(filterState) {
  return (0, _some2.default)(filterState, function (legFilterState) {
    return checkMultiSelectFilterStateReset(legFilterState);
  });
}
function checkAirportFilterStateReset(filterState) {
  return (0, _some2.default)(filterState, function (legFilterState) {
    var originHasReset = checkMultiSelectFilterStateReset((0, _get2.default)(legFilterState, 'origin'));
    var destinationHasReset = checkMultiSelectFilterStateReset((0, _get2.default)(legFilterState, 'destination'));
    return originHasReset || destinationHasReset;
  });
}
function checkPriceFilterStateReset(_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
    min = _ref2.min,
    max = _ref2.max,
    from = _ref2.from,
    to = _ref2.to;
  return min < from || max > to;
}
function checkFilterItemSelected(_ref3) {
  var filterKey = _ref3.filterKey,
    filterState = _ref3.filterState,
    filterPayload = _ref3.filterPayload;
  switch (filterKey) {
    case 'airline':
      return checkMultiSelectFilterItemSelected(filterState, filterPayload);
    case 'airport':
      return checkAirportFilterItemSelected(filterState, filterPayload);
    case 'stop':
      return checkMultiSelectFilterItemSelected(filterState, filterPayload);
    case 'departureTime':
      return checkNestedMultiSelectFilterItemSelected(filterState, filterPayload);
    case 'arrivalTime':
      return checkNestedMultiSelectFilterItemSelected(filterState, filterPayload);
    default:
      return false;
  }
}
function checkMultiSelectFilterItemSelected(filterState, filterPayload) {
  return !!(0, _find2.default)(filterState, _objectSpread(_objectSpread({}, filterPayload), {}, {
    selected: true
  }));
}
function checkNestedMultiSelectFilterItemSelected(filterState, filterPayload) {
  var code = filterPayload.code,
    index = filterPayload.index;
  return checkMultiSelectFilterItemSelected((0, _get2.default)(filterState, index), {
    code: code
  });
}
function checkAirportFilterItemSelected(filterState, filterPayload) {
  var code = filterPayload.code,
    type = filterPayload.type,
    index = filterPayload.index;
  return checkMultiSelectFilterItemSelected((0, _get2.default)(filterState, index + "." + type), {
    code: code
  });
}
function checkAllFilterItemsSelected(_ref4) {
  var filterKey = _ref4.filterKey,
    filterState = _ref4.filterState,
    filterCode = _ref4.filterCode;
  switch (filterKey) {
    case 'airline':
      return checkMultiSelectFilterItemSelected(filterState, {
        code: filterCode
      });
    case 'airport':
      return checkAllAirportFilterItemsSelected(filterState, filterCode);
    case 'stop':
      return checkMultiSelectFilterItemSelected(filterState, {
        code: filterCode
      });
    case 'departureTime':
      return checkAllNestedMultiSelectFilterItemsSelected(filterState, filterCode);
    case 'arrivalTime':
      return checkAllNestedMultiSelectFilterItemsSelected(filterState, filterCode);
    default:
      return false;
  }
}
function checkAllNestedMultiSelectFilterItemsSelected(filterState, filterCode) {
  return (0, _every2.default)(filterState, function (legFilterState) {
    var filterItem = (0, _find2.default)(legFilterState, {
      code: filterCode
    });
    return !filterItem || filterItem.selected;
  });
}
function checkAllAirportFilterItemsSelected(filterState, filterCode) {
  return (0, _every2.default)(filterState, function (legFilterState) {
    var originFilterItem = (0, _find2.default)((0, _get2.default)(legFilterState, 'origin'), {
      code: filterCode
    });
    var destinationFilterItem = (0, _find2.default)((0, _get2.default)(legFilterState, 'destination'), {
      code: filterCode
    });
    return (!originFilterItem || originFilterItem.selected) && (!destinationFilterItem || destinationFilterItem.selected);
  });
}
var _default = exports.default = {
  checkFilterStateReset: checkFilterStateReset,
  checkSubFilterStateReset: checkSubFilterStateReset,
  checkFilterItemSelected: checkFilterItemSelected,
  checkAllFilterItemsSelected: checkAllFilterItemsSelected
};